import { Line } from "rc-progress";
import { useContext, useEffect, useState } from "react";
import { getProgressBarData } from "./house-service";
import { SoldTicketsProgress } from "./types";
import { HouseCompetitionData } from "./contextProvider";
import Skeleton from "react-loading-skeleton";

const ProgressBar = () => {
  const [data, setData] = useState<SoldTicketsProgress>();
  const { prizeId } = useContext(HouseCompetitionData);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (prizeId) {
      getSoldTicketsProgress();
    }
  }, [prizeId]);

  const getSoldTicketsProgress = async () => {
    try {
      const response = await getProgressBarData(prizeId);
      const { SoldTickets, TotalTickets, SoldPercentage } = (await response.json()) as SoldTicketsProgress;
      setData({ SoldTickets, TotalTickets, SoldPercentage });
    } catch (error) {
      console.error("Error fetching sold tickets progress:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <Skeleton inline highlightColor="#fff" height={50} containerClassName="h-[50] w-full bg-[#f1f1f1]" />
  ) : (
    <div className="flex flex-col items-center w-full rounded-lg py-2 px-3 lg:px-6 bg-white lg:max-w-[405px] font-roboto">
      <Line
        percent={Number(data?.SoldPercentage)}
        strokeWidth={2}
        strokeColor="#FF8200"
        trailWidth={2}
        className="h-1.5 w-full rounded-full mb-[11px] first-of-type:[&>path]:stroke-[#E0E0E0]"
      />
      <div className="flex justify-between w-full items-center">
        <div className={"text-primary text-sm leading-5 font-semibold"}>{data?.SoldPercentage}% sold</div>

        {data?.SoldTickets !== null && (
          <div className="flex items-center">
            <div className={"mr-0.5"}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                className={"size-5 flex"}>
                <path
                  d="M19 8.12234V4.66634C19 3.92967 18.4033 3.33301 17.6666 3.33301H2.99996C2.26329 3.33301 1.66663 3.92967 1.66663 4.66634V8.12234C2.44196 8.39767 2.99996 9.13034 2.99996 9.99967C2.99996 10.869 2.44196 11.6017 1.66663 11.877V15.333C1.66663 16.0697 2.26329 16.6663 2.99996 16.6663H17.6666C18.4033 16.6663 19 16.0697 19 15.333V11.877C18.2246 11.6017 17.6666 10.869 17.6666 9.99967C17.6666 9.13034 18.2246 8.39767 19 8.12234ZM14.0346 9.30701L12.1 10.747L12.8186 13.049C12.9153 13.3577 12.5646 13.6123 12.3006 13.425L10.3333 12.0303L8.36596 13.425C8.10196 13.6123 7.75196 13.3577 7.84796 13.049L8.56663 10.747L6.63196 9.30701C6.37263 9.11434 6.50663 8.70234 6.82996 8.69834L9.24129 8.67034L10.0133 6.38567C10.1166 6.07967 10.55 6.07967 10.6533 6.38567L11.4253 8.67034L13.8366 8.69834C14.16 8.70167 14.294 9.11368 14.0346 9.30701Z"
                  fill="#898994"
                />
              </svg>
            </div>
            <div className={"inline-flex items-center"}>
              <span className={"text-sm text-gray-5 leading-5 font-medium uppercase"}>{data?.SoldTickets}</span>
              <span className={"text-sm text-gray-5 px-1 leading-5 font-medium"}> / </span>
              <span className={"text-sm text-primary leading-5 font-medium uppercase"}>{data?.TotalTickets}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
